import { createSlice } from '@reduxjs/toolkit';

import getActiveMenuCategories from '../thunks/getActiveMenuCategories';

import MenuCategoryInitialState from './MenuCategoryInitialState';

export const menuCategorySlice = createSlice({
  name: 'Common/MenuCategory',
  initialState: MenuCategoryInitialState,
  reducers: {
    setMenuCategories: (state, action) => {
      state.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActiveMenuCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(getActiveMenuCategories.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload !== undefined) {
          state.data = action.payload;
        }
        return state;
      })
      .addCase(getActiveMenuCategories.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setMenuCategories } = menuCategorySlice.actions;

export default menuCategorySlice.reducer;
